import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "hover-blue"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createBlock(_component_a_upload, {
    class: "hmd-btn",
    name: "file",
    multiple: true,
    "show-upload-list": false,
    "before-upload": _ctx.beforeUpload,
    "custom-request": _ctx.customRequest,
    disabled: _ctx.disabled,
    accept: _ctx.accept
  }, {
    default: _withCtx(() => [
      (!_ctx.isTextButton)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            disabled: _ctx.disabled,
            loading: _ctx.uploading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonText || "文件导入"), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.buttonText || "本地文件导入"), 1))
    ]),
    _: 1
  }, 8, ["before-upload", "custom-request", "disabled", "accept"]))
}